__turbopack_context__.v({
  "backButton": "levelMenu-module__G-2K9G__backButton",
  "levelMenuText": "levelMenu-module__G-2K9G__levelMenuText",
});
